import { nextExerciseDetailsActionTypes } from '../exercise/Constants';
import { isLoading } from '../exercise/Selectors';
import { resultTabActionTypes } from './Constants';
import { all, call, put, takeLatest, select, take } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as resultTabActions from './Actions';

export default function* () {
	yield all([
		yield takeLatest(
			resultTabActionTypes.GET_RESULT_TAB_SUMMARY,
			handleResultTabSummaryRequest,
		),
		yield takeLatest(
			resultTabActionTypes.GET_RESULT_TAB_RESULTS,
			handleResultTabResultsRequest,
		),
	]);
}

export function* handleResultTabSummaryRequest(action) {
	try {
		const { exerciseId, groupId, query } = action.payload;
		const isProcessing = yield select(isLoading);

		if (isProcessing) {
			yield take(nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_SUCCESS);
		}

		const { data } = yield call(
			processRequest,
			`public/exercises/${exerciseId}/results`,
			'GET',
			{
				group_id: groupId,
				...query,
			},
		);

		yield put(resultTabActions.getResultTabSummarySuccess(data.exercise));
	} catch (e) {
		yield put(resultTabActions.getResultTabSummaryError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleResultTabResultsRequest(action) {
	try {
		const { exerciseId, query } = action.payload;
		const isProcessing = yield select(isLoading);

		if (isProcessing) {
			yield take(nextExerciseDetailsActionTypes.SEND_QUESTION_ANSWER_SUCCESS);
		}
		const { data } = yield call(
			processRequest,
			`public/exercises/${exerciseId}/questions`,
			'GET',
			query,
		);

		yield put(resultTabActions.getResultTabResultsSuccess(data.questions));
	} catch (e) {
		yield put(resultTabActions.getResultTabResultsError());
		yield put(errorHandlerActions.handleError(e));
	}
}
